import React, {useContext, useEffect, useRef, useState} from 'react';
import { IonApp, IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonItem, IonList, IonSplitPane, IonMenuButton, IonButton, IonButtons, IonInput, IonModal, IonGrid, IonRow, IonCol, IonSlides } from '@ionic/react';
import { IonTabs, IonTabBar, IonTabButton, IonText, IonLabel, IonFooter, IonSlide, IonImg, IonRouterOutlet } from '@ionic/react';
import { Redirect} from 'react-router-dom';

import '../../../css/layout.css';

import { ShowProductPicsModal } from './Modal_ShowProductPics';
import { Modal_AddIngredientToRecipe} from './Modal_AddIngredient_To_Recipe';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';




 export function ViewRecipeDetailDataModal (props) {



    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);


    let [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);
    let [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [employeeID, setEmployeeID] = useState(authenticatedMerchent_context.employeeID);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL] = useState(authenticatedMerchent_context.baseURL);
    
    let [products, setProducts] = useState([]);
    let [selectedIdx, setSelectedIdx] = useState(0);

    let [productID, setProductID] = useState(props.data.productID);
    let [productName, setProductName] = useState(props.data.productName);

    let [productSalePrice, setProductSalePrice] = useState(props.data.productSalePrice);
    let [productPublicPrice, setProductPublicPrice] = useState(props.data.productPublicPrice);
    let [productPicsModal, setProductPicsModal] = useState(false);
    let [viewProductDetailsData, setViewProductDetailsData] = useState([]);
    let [showProductDetails, setShowProductDetails] = useState(false);

    let [productPic1, setProductPic1] = useState(null);
    let [productPic2, setProductPic2] = useState(null);
    let [productPic3, setProductPic3] = useState(null);
    let [productPic4, setProductPic4] = useState(null);

    let [selectedFile, setSelectedFile] = useState(null);

    let [row_1, setRow_1] = useState(false);
    let [row_2, setRow_2] = useState(false);
    let [row_3, setRow_3] = useState(false);
    let [row_4, setRow_4] = useState(false);
    let [row_5, setRow_5] = useState(false);
    let [row_6, setRow_6] = useState(false);
    let [row_7, setRow_7] = useState(false);
    let [row_8, setRow_8] = useState(false);
    let [row_9, setRow_9] = useState(false);
    let [row_10, setRow_10] = useState(false);
    let [row_11, setRow_11] = useState(false);


    let [openAddIngredientModal, setOpenAddIngredientModal] = useState(false);
    // let createProductAddition_type = useRef(props.data.addition_type);
    // let createProductTypeRef = useRef(props.data.itemType);
    // let createProductDescriptionRef = useRef(props.data.itemDescription);
    // let createProductPartNumRef = useRef(props.data.vendorPartNum);
    // let createProductPhoneNumberRef = useRef(props.data.vendorPartNum);
    // let createProductAddressRef = useRef(props.data.vendorAddress);
    // let createProductCityRef = useRef(props.data.vendorCity);
    // let createProductCountryRef = useRef(props.data.vendorCountry);
    // let createProductCostPerUnitRef = useRef(props.data.costPerUnit);
    // let createProductSalePriceRef = useRef(props.data.salePrice);
    // let createProductQtyInUse = useRef(props.data.qtyInUse);
    // let createProductDateCreated = useRef(props.data.dateCreated);
    // let createProductAddedBy = useRef(props.data.addedBy);


    let [createProductAddition_type, setCreateProductAddition_type] = useState(props.data.addition_type);

    let [productType, setProductType] = useState(null);
    let [productDescription, setProductDescription] = useState(null);
    let [productPartNum, setProductPartNum] = useState(null);
    let [productPhoneNumber, setProductPhoneNumber] = useState(null);
    let [productAddress, setProductAddress] = useState(null);
    let [productCity, setProductCity] = useState(null);
    let [productCountry, setProductCountry] = useState(null);
    let [productCostPerUnit, setProductCostPerUnit] = useState(null);
    //let [productSalePrice, setProductSalePrice] = useState(null);
    let [productQtyInUse, setProductQtyInUse] = useState(null);
    let [productDateCreated, setProductDateCreated] = useState(null);
    let [productAddedBy, setProductAddedBy] = useState(null);
    let [attachment, setAttachment] = useState(null);
    let [quantityAvailable, setQuantityAvailable] = useState(null);
    let [quantityUnits, setQuantityUnits] = useState(null);
    let [productIsActivated, setProductIsActivated] = useState(null);

    let [itemIDList, setItemIDList] = useState([]);

    const parseArray = (raw) => {
        try {
          let v = raw;
          if (typeof v === "string") v = JSON.parse(v);
          while (typeof v === "string" && (/^\s*[\[{]/.test(v))) v = JSON.parse(v);
          return Array.isArray(v) ? v : [];
        } catch {
          console.warn("Bad itemID_list JSON:", raw);
          return [];
        }
      };

    const populateFormFromProduct = (p) => {
        setProductID(p.productID ?? "");
        setProductType(p.productType ?? "");
        setProductName(p.productName ?? "");
        setProductDescription(p.productDescription ?? ""); // adjust if your payload has it
        setProductPartNum(p.productPartNum ?? "");
        setProductPhoneNumber(p.productPhoneNumber ?? "");
        setProductAddress(p.productAddress ?? "");         // adjust indices below to include these
        setProductCity(p.productCity ?? "");
        setProductCostPerUnit(p.productCostPerUnit ?? "");
        setProductSalePrice(p.productSalePrice ?? "");
        setProductPic1(p.productPic1 ?? "");
        setProductPic2(p.productPic2 ?? "");
        setProductPic3(p.productPic3 ?? "");
        setProductPic4(p.productPic4 ?? "");
        setProductDateCreated(p.productDateCreated ?? "");
        setProductAddedBy(p.productAddedBy ?? "");
        setProductIsActivated(p.productIsActivated ?? "");
        setItemIDList(Array.isArray(p.itemID_list) ? p.itemID_list : []);
      };
      
      // When products load or selection changes, populate the form

function getProductDetailData() {

    
    const requestOptions = {
        method: 'POST',
        headers: {
            'Accept': 'text/html, application/json',
            'content-type': 'application/json',
        },
        body: JSON.stringify({
            Tracker: '74301_productList_restaurant_details',
            user: acctID,
            xProductID: props.data.productID,
            sessionID: sessionID,
        }),
    };

    fetch(baseURL + 'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {


                const rows = res.toString().split("~~~");
                const parsed = rows.slice(0, -1).map((row) => {
                    const cols = row.split("|");

                    // Adjust these indices to your exact backend order
                    const itemID_list = parseArray(cols[1]); // JSON array-of-objects in col 1
                    return {
                        productID: cols[0],
                        itemID_list,
                        productType: cols[2],
                        productName: cols[3],
                        productPartNum: cols[4],
                        productPhoneNumber: cols[5],
                        // If your backend sends these, set proper indices:
                        //productAddress: cols[6] ?? "",          // <-- adjust if different
                        //productCity: cols[7] ?? "",             // <-- adjust if different
                        productCostPerUnit: Number(cols[6]) || 0,
                        productSalePrice: Number(cols[7]) || 0,
                        productPic1: cols[8] || "",
                        productPic2: cols[9] || "",
                        productPic3: cols[10] || "",
                        productPic4: cols[11] || "",
                        productDateCreated: cols[12] || "",
                        productAddedBy: cols[13] || "",
                        productIsActivated: cols[14] || "",
                        // productDescription: cols[?] || "",   // include if provided
                    };
                });
                setProducts(parsed);
                setSelectedIdx(0); // show the first one
        });
}

function updateProduct() {

    let formData = new FormData();
    //formData.append('xProductPics', totalProductPics);
    //formData.append('xProductPics', [ProductPic1, ProductPic2, ProductPic3, ProductPic3]);
    formData.append('Tracker', '74300_update_product_recipe');
    formData.append('user', acctID);
    formData.append('merchantSchema', schema);
    formData.append('xProductID', props.data.productID);
    formData.append('xInventoryItemID_list', JSON.stringify(itemIDList));
    formData.append('xInventoryProductType', productType);
    formData.append('xInventoryProductName', productName);
    formData.append('xInventoryProductDescription', productDescription);
    formData.append('xInventoryProductPartNum', productPartNum);
    formData.append('xProductPhoneNumber', productPhoneNumber);
    formData.append('xProductAddressNumber', productAddress);
    formData.append('xProductCity', productCity);
    formData.append('xProductCountry', productCountry);
    formData.append('xInventoryProductCostPerUnit', productCostPerUnit);
    formData.append('xInventoryProductSalePrice', productSalePrice);
    //formData.append('xPic1', productPic1);
    //formData.append('xPic2', productPic2);
    //formData.append('xProductPic3', productPic3);
    //formData.append('xProductPic4', productPic4);
    //formData.append('xAttachment', attachment);
    formData.append('xProductDateCreated', productDateCreated);
    formData.append('xCreatedByEmployee', productAddedBy);
    formData.append('xIsActivated', productIsActivated);
    //formData.append('xStoreFront', productPublicPrice);
    //formData.append('xProductQuantityAvailable', productQtyInUse);
    formData.append('sessionID', sessionID);



    const requestOptions = {
        enctype: 'multipart/form-data',
        method:'POST',
        //credentials: 'include',
        file: formData,
        body: formData,
        contentType: false,
        processData: false,
    }
    


    fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
    .then(res => res.text())
    .then(data => {

        alert(data);

        getProductDetailData(); 

    })
    .catch(error => {
        console.error(error);
    })

}


const handleItemFieldChange = (id, field, val) => {
    setItemIDList(prev =>
      prev.map(it => (it.id === id ? { ...it, [field]: val ?? "" } : it))
    );
  };

function closeModalHandler() {

    props.closeModal(false);
}

function addItemID_list(event)
{
    //alert("In Update Address");
    //alert(event)


    /*const newItem = {
        id: event[1], // Generate a new ID
        name: event[2], // Generate a new ID
        qtyCost: event[3],
        measurmentUnit: event[4], // Random price
        };*/


    setItemIDList([...itemIDList, event]);

    //setvViewIonPopover(false);
    //props.confirmAdd(newItem);

}

useEffect(() => {
    if (products.length) populateFormFromProduct(products[selectedIdx] || products[0]);
  }, [products, selectedIdx]);

useEffect(() =>  {

    //alert("In produt detals modal");
    //alert(props.data.productID);

        
    getProductDetailData(); 

}, [])

            return(

                <React.Fragment>
                {props.openModal == true ?
                (
            <IonModal id='showProductDetails' isOpen={ props.openModal}>

                <IonHeader style={{color: "black"}}>
                        <IonGrid>
                            <IonRow>
                                <IonCol size='12'>
                                    <IonText>PRODUCT DETAILS</IonText>
                                </IonCol>
                            </IonRow>
                            <IonRow>
                                <IonCol size='6'>Product ID</IonCol>
                                <IonCol size='6'>Product Name</IonCol>
                            </IonRow>
                            <IonRow >
                                <IonCol size='6'><IonText>{productID}</IonText></IonCol>
                                <IonCol size='6'><IonText>{productName}</IonText></IonCol>
                            </IonRow>
                        </IonGrid>
                    </IonHeader>
                    <IonContent className='grid_content'>
                        <IonGrid >
                            <IonRow>
                                <IonCol size="12">
                                    <IonButton  onClick={() => setOpenAddIngredientModal(true)}> ADD INGREDIENT </IonButton>
                                </IonCol>
                            </IonRow>
                            <IonRow>
                                <IonCol size='2'><h4>ID</h4></IonCol>
                                <IonCol size='4'><h4>NAME</h4></IonCol>
                                <IonCol size='3'><h4>COST</h4></IonCol>
                                <IonCol size='3'><h4>UNIT</h4></IonCol>
                            </IonRow>
                            {itemIDList.map((it) => {
                                return (
                                <IonRow key={it.id}>
                                    <IonCol size='2'>
                                        {it.id}
                                    </IonCol>
                                    <IonCol size='4'>
                                        {it.name}
                                    </IonCol>
                                    <IonCol size='3'>
                                        <IonInput className='professional-input'
                                        value={it.qtyCost}
                                        placeholder="Enter Cost"
                                        onIonChange={(e) => handleItemFieldChange(it.id, "qtyCost", (e.target.value ?? "").replace(",", "."))}
                                        ></IonInput>                                    
                                    </IonCol>
                                    <IonCol size='3'>
                                        <IonInput className='professional-input'
                                        value={it.measurmentUnit}
                                        placeholder="Enter Units"
                                        onIonChange={(e) => handleItemFieldChange(it.id, "measurmentUnit", e.target.value ?? "")}
                                        ></IonInput>  
                                    </IonCol>
                                </IonRow>
                                )}
                            )}
                            <IonRow>
                                <IonCol size='12'>
                                    <IonLabel className="form-label" position="stacked"> Product Type: </IonLabel>
                                    <IonInput className='professional-input'
                                    value={productType}
                                    placeholder="Enter Product Type"
                                    onIonChange={(e) => setProductType(e.target.value)}
                                    ></IonInput>
                                </IonCol>
                            </IonRow>  
                            <IonRow>
                                <IonCol size='12'>
                                    <IonLabel className="form-label" position="stacked"> Product Name: </IonLabel>
                                    <IonInput className='professional-input'
                                    value={productName}
                                    placeholder="Enter Product Name"
                                    onIonChange={(e) => setProductName(e.target.value)}
                                    ></IonInput>
                                </IonCol>
                            </IonRow>  
                            <IonRow>
                                <IonCol size='12'>
                                    <IonLabel className="form-label" position="stacked"> Product Description: </IonLabel>
                                    <IonInput className='professional-input'
                                    value={productDescription}
                                    placeholder="Enter Product Description"
                                    onIonChange={(e) => setProductDescription(e.target.value)}
                                    ></IonInput>
                                </IonCol>
                            </IonRow>  
                            <IonRow>
                                <IonCol size='12'>
                                    <IonLabel className="form-label" position="stacked"> Product Part Number: </IonLabel>
                                    <IonInput className='professional-input'
                                    value={productPartNum}
                                    placeholder="Enter Product Part Number"
                                    onIonChange={(e) => setProductPartNum(e.target.value)}
                                    ></IonInput>
                                </IonCol>
                            </IonRow>  
                            <IonRow>
                                <IonCol size='12'>
                                    <IonLabel className="form-label" position="stacked"> Product Phone Number: </IonLabel>
                                    <IonInput className='professional-input'
                                    value={productPhoneNumber}
                                    placeholder="Enter Product Phone Number"
                                    onIonChange={(e) => setProductPhoneNumber(e.target.value)}
                                    ></IonInput>
                                </IonCol>
                            </IonRow>  
                            {/*<IonRow>
                                <IonCol size='12'>
                                    <IonLabel className="form-label" position="stacked"> Product Address: </IonLabel>
                                    <IonInput className='professional-input'
                                    value={productAddress}
                                    placeholder="Enter Product Address"
                                    onIonChange={(e) => setProductAddress(e.target.value)}
                                    ></IonInput>
                                </IonCol>
                            </IonRow>  
                            <IonRow>
                                <IonCol size='12'>
                                    <IonLabel className="form-label" position="stacked"> Product City: </IonLabel>
                                    <IonInput className='professional-input'
                                    value={productCity}
                                    placeholder="Enter Product City"
                                    onIonChange={(e) => setProductCity(e.target.value)}
                                    ></IonInput>
                                </IonCol>
                            </IonRow>  
                            <IonRow>
                                <IonCol size='12'>
                                    <IonLabel className="form-label" position="stacked"> Product Country: </IonLabel>
                                </IonCol>
                                <IonCol size='12'>
                                    <select name="country" id='country' value={productCountry} onChange={(e) => setProductCountry(e.target.value)}>
                                        <option value='GHANA' selected>Ghana</option>
                                        <option value='USA'>USA</option>
                                        <option value='CHINA'>CHINA</option>
                                    </select>
                                </IonCol>
                                </IonRow>  */}
                            <IonRow>
                                <IonCol size='12'>
                                    <IonLabel className="form-label" position="stacked"> Product Cost Per Unit: </IonLabel>
                                    <IonInput className='professional-input'
                                    value={productCostPerUnit}
                                    placeholder="Enter Product Cost Per Unit"
                                    onIonChange={(e) => setProductCostPerUnit(e.target.value)}
                                    ></IonInput>
                                </IonCol>
                            </IonRow>  
                            <IonRow>
                                <IonCol size='12'>
                                    <IonLabel className="form-label" position="stacked"> Prodcut Sale Price: </IonLabel>
                                    <IonInput className='professional-input'
                                    value={productSalePrice}
                                    placeholder="Enter Product Sale Price"
                                    onIonChange={(e) => setProductSalePrice(e.target.value)}
                                    ></IonInput>
                                </IonCol>
                            </IonRow>  
                            <IonRow class='gridResultBody'>
                                <IonCol size='6' class='gridResultHeaders'>Product Images</IonCol>
                                <IonCol size='6' class='gridResultColumns'>
                                    <ShowProductPicsModal openModal={ productPicsModal } closeModal={() => setProductPicsModal(false)} data={{
                                    productPic1: productPic1, 
                                    productPic2: productPic2, 
                                    productPic3: productPic3, 
                                    productPic4: productPic4, 
                                    productID: productID, 
                                    productSalePrice: productSalePrice
                                    }}></ShowProductPicsModal>
                                    <IonButton class='gridResultColumnButton' onClick={() => setProductPicsModal(true)}> View </IonButton>
                                </IonCol>
                            </IonRow>
                            <IonRow>
                                <IonCol size='12'>
                                    <IonLabel className="form-label" position="stacked"> Date Created: </IonLabel>
                                    <IonInput className='professional-input'
                                    value={productDateCreated}
                                    placeholder="Date Created"
                                    onIonChange={(e) => setProductDateCreated(e.target.value)}
                                    ></IonInput>
                                </IonCol>
                            </IonRow>  
                            <IonRow>
                                <IonCol size='12'>
                                    <IonLabel className="form-label" position="stacked"> Created By Employee: </IonLabel>
                                    <IonInput className='professional-input'
                                    value={productAddedBy}
                                    placeholder="Created By"
                                    onIonChange={(e) => setProductAddedBy(e.target.value)}
                                    ></IonInput>
                                </IonCol>
                            </IonRow>  
                            <IonRow>
                                <IonCol size='12'>
                                    <IonLabel className="form-label" position="stacked"> Prodcut Is Active: </IonLabel>
                                    <IonInput className='professional-input'
                                    value={productIsActivated}
                                    placeholder="Status"
                                    onIonChange={(e) => setProductIsActivated(e.target.value)}
                                    ></IonInput>
                                </IonCol>
                            </IonRow>  
                             {/*<IonRow>
                                <IonCol size='12'>
                                    <IonLabel className="form-label" position="stacked"> Quantity Available: </IonLabel>
                                </IonCol>
                                <IonCol size='12'>
                                    <IonText>{quantityAvailable}</IonText>
                                </IonCol>
                               <IonCol size='12'>
                                    <IonInput className='professional-input'
                                    value={quantityAvailable}
                                    placeholder="Enter Quantity Available"
                                    onIonChange={(e) => setQuantityAvailable(e.target.value)}
                                    ></IonInput>
                                </IonCol>
                            </IonRow>  
                            <IonRow>
                                <IonCol size='12'>
                                    <IonLabel className="form-label" position="stacked"> Qty Units: </IonLabel>
                                </IonCol>
                                <IonCol size='12'>
                                    <select name="qtyUnitsRef" id='qtyUnitsRef' value={quantityUnits} onChange={(e) => setQuantityUnits(e.target.value)}>
                                        <option value='ea' selected>Quantity</option>
                                        <option value='g'>grams</option>
                                        <option value='kg'>Kilograms</option>
                                        <option value='L'>Liters</option>
                                    </select>
                                </IonCol>
                            </IonRow>  */}
                            </IonGrid>

                            {openAddIngredientModal == true && <Modal_AddIngredientToRecipe openModal={ openAddIngredientModal } closeModal={() => setOpenAddIngredientModal(false)} confirmAdd={addItemID_list}></Modal_AddIngredientToRecipe>}
                        
                        </IonContent>
                        <IonFooter class='grid_footer'>
                                <IonGrid>
                                {authenticatedMerchent_context.accessRights[0] == 'admin' && 
                                    <IonRow>
                                        <IonCol size="6">
                                            <IonButton onClick={() => updateProduct()}> Save </IonButton>
                                        </IonCol>
                                        <IonCol size="6">
                                            <IonButton  onClick={() => closeModalHandler()}>Cancel </IonButton>
                                        </IonCol>
                                    </IonRow>}
                                {authenticatedMerchent_context.accessRights[0] != 'admin' && 
                                    <IonRow>
                                        <IonCol size="12">
                                            <IonButton  onClick={() => closeModalHandler()}>Cancel </IonButton>
                                        </IonCol>
                                    </IonRow>}
                                </IonGrid>
                        </IonFooter>
                    </IonModal>) : null}
    </React.Fragment>
            )
}   



export default ViewRecipeDetailDataModal;